import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=9ef0a2d4&scoped=true&"
import script from "./AddTeam.vue?vue&type=script&lang=js&"
export * from "./AddTeam.vue?vue&type=script&lang=js&"
import style0 from "./AddTeam.vue?vue&type=style&index=0&id=9ef0a2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef0a2d4",
  null
  
)

export default component.exports